import stLogo from "../../assets/landing/st_logo_round.svg";
import zbLogo from "../../assets/landing/zb_logo_round.svg";
import smLogo from "../../assets/landing/sm_logo_round.svg";
import tmLogo from "../../assets/landing/tm_logo_round.svg";
import btLogo from "../../assets/landing/bt_logo_round.svg";
import bhLogo from "../../assets/landing/bh_logo_round.svg";

export const PUBLICATIONS = [
  { id: "st", logo: stLogo },
  { id: "zb", logo: zbLogo },
  { id: "sm", logo: smLogo },
  { id: "tm", logo: tmLogo },
  { id: "bt", logo: btLogo },
  { id: "bh", logo: bhLogo },
] as const;

export const SUPPORTED_LANGS = ["en", "zh"] as const;
export type LandingLang = (typeof SUPPORTED_LANGS)[number];
